import { PermissionT } from "../types";

export const noticeModalCrud = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "notice_modal_crud");
  return !!p;
};

export default noticeModalCrud;
